import { Outlet } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import useGTMTracker from "../../hooks/useGTMTracker";

const StudioLayout = () => {
  useGTMTracker();

  return (
    <>
      <main className="max-w-screen w-full min-h-screen flex flex-col justify-center max-w-[2560px] place-self-center">
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <div className="flex-1 h-full">
            <Outlet />
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
};

export default StudioLayout;
